<script>
export default {
  name: 'avaliacao-erro',
  props: {
    etapa: String
  },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {}
}
</script>
<template>
  <div class="avaliacao-erro">
    <div class="page-content">
      <div class="page-header-content">
        <h2 class="page-title">Ops, ocorreu um erro</h2>
      </div>
    </div>

    <div class="box pa-5">
      <div class="text-xs-center">
        <h3 class="title mb-2">Atenção candidato!</h3>
        Sua avaliação já foi finalizada e/ou ficou indisponível.
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Erro.vue?b795187e